import { ContactService, UserService } from "@/services";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  name: "phone-input",
  data() {
    return {
      phoneInput: "",
      isRequesting: false
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.userInfo.getters.GET_USER_INFO,
      userVerify: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),
    phone() {
      return this.userInfo?.phone;
    },
    isPhoneCodeValid() {
      if (this.phoneCode) {
        const phoneRegex = /^\d{1,6}$/;
        return phoneRegex.test(this.phoneCode);
      }
      return false;
    },
    isPhoneValid() {
      if (this.phoneInput) {
        const phoneRegex = /^(0[1-9]{2})[2-9][0-9]{7}$/;
        return phoneRegex.test(this.phoneInput);
      }
      return false;
    },
    isHomePhoneSubmitted() {
      return (
        this.userVerify?.is_home_phone_submitted ||
        this.userVerify?.is_home_phone_verified
      );
    }
  },
  methods: {
    ...mapActions({
      setPhone: types.userVerifyInfo.actions.SET_PHONE_STATUS,
      setVerifyData: types.userVerifyInfo.actions.SET_USER_VERIFY_INFO,
      setUserData: types.userInfo.actions.ACTION_USER_INFO
    }),

    finishRequest() {
      this.isRequesting = false;
    },
    storePhone() {
      ContactService.storePhone(this.phoneInput)
        .then(res => {
          this.getAuthVerifyInfo();
          this.getUserInfo();
          this.$toast.success(res.data.message);
        })
        .finally(() => this.finishRequest());
    },
    getAuthVerifyInfo() {
      UserService.getVerifyInfo().then(response => {
        this.setVerifyData(response.data.data);
      });
    },
    getUserInfo() {
      UserService.getInfo().then(response => {
        this.setUserData(response.data.data);
      });
    }
  }
};
